import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import React, { useEffect, useReducer, useState } from "react";
import { useSelector } from "react-redux";
import { getTheme } from "../highChartTheme";

const DLERunChart = (props: { dleRunChart: any }) => {
  const [animate, setAnimate] = useState("");
  let isLightMode = useSelector((state: any) => state.theme.lightMode);

  useEffect(() => {
    setTimeout(() => {
      setAnimate("animate");
    }, 250);
  }, []);

  const options = {
    chart: {
      backgroundColor: "transparent",
      type: "line",
    },

    // credits: {
    //   enabled: false,
    // },

    series: [
      {
        name: "Target %",
        type: "line",
        lineWidth: 2,
        legendcolor: "#FFFFFF",
        data: props.dleRunChart.map(
          (x1: { totalTarget: any }) => x1.totalTarget
        ),
        color: "#FFFFFF",
      },
      {
        name: "DLE %",
        type: "line",
        lineWidth: 4,
        legendcolor: "#1b9fef",
        data: props.dleRunChart.map((x1: { percentage: any }) => x1.percentage),

        color: "#1b9fef",
      },
    ],
  };

  return (
    <section className="page-content">
      <div className="site-view tier-wrap admin-console-wrapper">
        <div
          className={"site-list " + animate}
          style={{
            backgroundColor: isLightMode ? "#d3d3d3" : "#2f3030",
          }}
        >
          <HighchartsReact
            highcharts={Highcharts}
            options={{
              ...options,
              ...getTheme(
                "DLE Run Chart",
                isLightMode,
                props.dleRunChart.map((x1: { xaxis: any }) => x1.xaxis)
              ),
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default DLERunChart;
